var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivityUnlike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 23.431,
    viewBox: "0 0 25 23.431",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e31e26;stroke:rgba(0,0,0,0);stroke-miterlimit:10;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.5,1a6.243,6.243,0,0,0-4.32,1.77L15.91,5.5,11.41,10l4,4L11.7,17.71,10.29,16.3l2.29-2.29-4-4,4.5-4.5L10.22,2.65A5.306,5.306,0,0,0,6.53,1.02H6.5A6.743,6.743,0,0,0,0,8c0,6.92,10.96,14.6,11.43,14.92l.57.4.57-.4C13.04,22.6,24,14.92,24,8A6.774,6.774,0,0,0,17.5,1Z",
    transform: "translate(0.5 -0.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityUnlike);
export default __webpack_public_path__ + "static/media/activity-unlike.9b5fd36108f9a46cb9ae0a62b7d08412.svg";
export { ForwardRef as ReactComponent };